export default "__VITE_ASSET__DRXiLY9P__"